import React from 'react';

const FREQUENCIES = [
  {
    id: 'daily',
    label: 'Daglig',
    sublabel: 'Hver dag',
    description: 'Få de siste veioppdateringene og nyheter hver morgen.',
    icon: '☀',
    accent: '#E8630A'
  },
  {
    id: 'weekly',
    label: 'Ukentlig',
    sublabel: 'Hver mandag',
    description: 'En grundig oppsummering av uken — veier, bom og tjenester.',
    icon: '📅',
    accent: '#3B6FD4'
  },
  {
    id: 'monthly',
    label: 'Månedlig',
    sublabel: 'Første i måneden',
    description: 'Månedlig sammendrag med de viktigste oppdateringene.',
    icon: '🗓',
    accent: '#8A95A3'
  }
];

const FrequencyToggle = ({ frequency, setFrequency }) => {
  return (
    <div style={{
      background: '#0A1220',
      border: '1px solid rgba(255,255,255,0.06)',
      padding: '40px',
      position: 'relative',
      overflow: 'hidden',
      marginBottom: '32px'
    }}>
      {/* Color block accent */}
      <div style={{
        position: 'absolute', top: 0, left: 0,
        width: '4px', height: '100%',
        background: 'linear-gradient(to bottom, #3B6FD4, #E8630A)'
      }} />

      {/* Background texture number */}
      <div style={{
        position: 'absolute', right: '-10px', top: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: '120px', fontWeight: 900,
        color: 'rgba(232,99,10,0.04)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none'
      }}>02</div>

      <div style={{ paddingLeft: '20px', position: 'relative', zIndex: 1 }}>
        <div style={{
          fontFamily: 'Syne, sans-serif',
          fontSize: '0.65rem', fontWeight: 700,
          color: '#3B6FD4', letterSpacing: '0.2em',
          textTransform: 'uppercase', marginBottom: '12px'
        }}>STEG 02 — FREKVENS</div>

        <div style={{
          fontFamily: 'Impact, Arial Black, sans-serif',
          fontSize: 'clamp(22px, 3vw, 32px)',
          fontWeight: 900, color: '#EEF0F2',
          letterSpacing: '-0.02em', textTransform: 'uppercase',
          marginBottom: '8px'
        }}>HVOR OFTE?</div>

        <p style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.9375rem', color: 'rgba(138,149,163,0.7)',
          lineHeight: 1.6, marginBottom: '32px', maxWidth: '480px'
        }}>
          Velg hvor ofte du ønsker å motta nyhetsbrev fra NordPass.
        </p>

        {/* Frequency options */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '16px'
        }}>
          {FREQUENCIES?.map((freq) => {
            const isSelected = frequency === freq?.id;
            return (
              <button
                key={freq?.id}
                onClick={() => setFrequency?.(freq?.id)}
                style={{
                  padding: '24px 20px',
                  background: isSelected ? `rgba(${freq?.accent === '#E8630A' ? '232,99,10' : freq?.accent === '#3B6FD4' ? '59,111,212' : '138,149,163'},0.12)` : 'rgba(255,255,255,0.02)',
                  border: `2px solid ${isSelected ? freq?.accent : 'rgba(255,255,255,0.08)'}`,
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'all 200ms ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'; }}
                onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
              >
                {/* Selected indicator */}
                {isSelected && (
                  <div style={{
                    position: 'absolute', top: '12px', right: '12px',
                    width: '20px', height: '20px',
                    background: freq?.accent,
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="square">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                )}

                {/* Toggle switch visual */}
                <div style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  marginBottom: '14px'
                }}>
                  <div style={{
                    width: '44px', height: '24px',
                    background: isSelected ? freq?.accent : 'rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    position: 'relative',
                    transition: 'background 200ms ease',
                    flexShrink: 0
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '3px',
                      left: isSelected ? '23px' : '3px',
                      width: '18px', height: '18px',
                      background: '#EEF0F2',
                      borderRadius: '50%',
                      transition: 'left 200ms ease',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                    }} />
                  </div>
                  <span style={{ fontSize: '1.2rem' }}>{freq?.icon}</span>
                </div>

                <div style={{
                  fontFamily: 'Syne, sans-serif',
                  fontSize: '1rem', fontWeight: 800,
                  color: isSelected ? freq?.accent : '#EEF0F2',
                  letterSpacing: '-0.02em',
                  marginBottom: '4px',
                  transition: 'color 200ms ease'
                }}>{freq?.label}</div>

                <div style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.6875rem', color: 'rgba(138,149,163,0.6)',
                  letterSpacing: '0.05em', marginBottom: '10px'
                }}>{freq?.sublabel}</div>

                <div style={{
                  fontFamily: 'Georgia, serif', fontStyle: 'italic',
                  fontSize: '0.8125rem', color: 'rgba(138,149,163,0.65)',
                  lineHeight: 1.55
                }}>{freq?.description}</div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FrequencyToggle;
